var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.667 5.331a1.5 1.5 0 0 1-.26-.023A1.33 1.33 0 0 1 1.359 4.26c-.026-.129-.026-.284-.026-.593 0-.31 0-.465.026-.594a1.33 1.33 0 0 1 1.048-1.047C2.535 2 2.69 2 3 2h10c.31 0 .465 0 .594.026.528.105.942.518 1.047 1.047.026.129.026.284.026.594s0 .464-.026.593a1.33 1.33 0 0 1-1.047 1.048 1.5 1.5 0 0 1-.26.023M6.666 8.667h2.666M2.667 5.333h10.666V10.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H5.867c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108z"
  })));
};
export default SvgArchive;